import { render, staticRenderFns } from "./AutoCard.vue?vue&type=template&id=68b747dc&scoped=true"
import script from "./AutoCard.vue?vue&type=script&lang=js"
export * from "./AutoCard.vue?vue&type=script&lang=js"
import style0 from "./AutoCard.vue?vue&type=style&index=0&id=68b747dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b747dc",
  null
  
)

export default component.exports